<div class="synchronization-module">
  <div class="panel">

    <div class="row align-items-center">
      <div class="form-group col-4">
        <div class="row" *ngIf="report != null">
          <button type="button" [style]="{'width':'80%'}" class="btn btn-primary sync-btn"
            [disabled]="!instanceId || isBUdown" (click)="downloadToBI()">
            <span class="pi pi-chart-bar"></span>
            <span>Publish To Power BI</span>
          </button>
        </div>
      </div>

      <div class="col-4 text-center">
        <h3>{{ 'SYNCHRONIZATION.Title' | translate }}</h3>
      </div>

      <div class="col-4"></div>
    </div>



    <div class="row">
      <div [ngClass]="!currentProject ? 'form-group col-offset-3 col-6' : 'form-group col-4'">
        <label *ngIf="instanceList?.length > 1" for="projectList">{{'SYNCHRONIZATION.Instance' | translate}}:</label>
        <p-select *ngIf="instanceList?.length > 1" name="instanceList" [options]="instanceList" optionLabel="Name"
          [style]="{'width':'80%'}" [(ngModel)]="currentInstance" (ngModelChange)="resetProjects()"
          (click)="resetInstance()" scrollHeight="300px"></p-select>

        <label for="projectList">{{'SYNCHRONIZATION.Project' | translate}}:</label>

        <div class="d-flex align-items-center" style="gap: 8px;">

          <p-select id="projectList" [options]="projectList" [placeholder]="'SHARED.PleaseSelect' | translate"
            [(ngModel)]="currentProject" [disabled]="!instancesLoaded" (ngModelChange)="getProjectData()"
            optionLabel="ProjectId" [showClear]="true" [filter]="true" filterBy="Name,ProjectId" scrollHeight="300px"
            [style]="{'width':'80%'}" (click)="this.loadProjects()" [virtualScroll]="projectList?.length > 1000"
            [virtualScrollItemSize]="53">
            <ng-template let-it pTemplate="selectedItem">
              <span *ngIf="it"><b>{{it?.ProjectId}}</b>: {{it?.Name}}</span>
            </ng-template>
            <ng-template let-it pTemplate="item">
              <div class="flex flex-column gap-1">
                <strong>{{it?.ProjectId}}</strong>
                <span>{{it?.Name}}</span>
              </div>
            </ng-template>
          </p-select>

          <p-button type="button" icon="pi pi-exclamation-circle" class="p-button-rounded p-button-text"
            (click)="loadMissedProjects()" title="Show Missing Projects"></p-button>
        </div>
      </div>
      <div class="form-group col-4">
        <div class="row" *ngIf="report != null">
          <button type="button" class="btn btn-primary sync-btn"
            [disabled]="!currentProject || report.Completed || isBUdown" (click)="download()">
            <span class="pi pi-cloud-download"></span>
            <span>{{'SYNCHRONIZATION.PublishLookahead' | translate}}</span>
          </button>
        </div>
        <div class="row" *ngIf="syncData1 != null">
          <span class="sync-comment">{{'SYNCHRONIZATION.LastSynchronized' | translate}} <b>{{syncData1.LastAttempt |
              momentPipe: 'L HH:mm:ss'}}</b>
            {{'SYNCHRONIZATION.By' | translate}} <b>{{syncData1.UserName}}</b></span>
        </div>
      </div>
      <div class="form-group col-4">
        <div class="row" *ngIf="report != null">
          <button class="btn btn-primary sync-btn" [disabled]="!report || report.Completed || isBUdown"
            (click)="upload()">
            <span class="pi pi-cloud-upload"></span>
            <span>{{'SYNCHRONIZATION.UpdateActivity' | translate}}</span>
          </button>
        </div>
        <div class="row" *ngIf="syncData2 != null">
          <span class="sync-comment">{{'SYNCHRONIZATION.LastSynchronized' | translate}} <b>{{syncData2.LastAttempt |
              momentPipe: 'L HH:mm:ss'}}</b>
            {{'SYNCHRONIZATION.By' | translate}} <b>{{syncData2.UserName}}</b></span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="currentProject && initialDownload === true">
    <div class=col-12>
      <p>
        {{'SYNCHRONIZATION.Project' | translate}} <b>{{currentProject.ProjectId}}</b> ({{currentProject.Name}})
        {{'SYNCHRONIZATION.IsBeingDownloaded' | translate}}<br />
        {{'SYNCHRONIZATION.MightTake' | translate}}
      </p>
    </div>
  </div>
  <div *ngIf="report != null">
    <div class="panel">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <h3>{{'SYNCHRONIZATION.DeltaReport' | translate}}</h3>
            </div>
          </div>
          <div class="col-8">
            <div class="row mb-3 align-items-center">
              <div class="col-sm-4">
                <label>{{'SYNCHRONIZATION.ProjectName' | translate}}:</label>
              </div>
              <div class="col-sm-6">
                <span>{{report.ProjectName}}</span>
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-sm-4">
                <label>{{'SYNCHRONIZATION.PrimaveraId' | translate}}:</label>
              </div>
              <div class="col-sm-6">
                <span>{{report.ProjectCode}}</span>
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-sm-4">
                <label>{{'SYNCHRONIZATION.TotalActivities' | translate}}:</label>
              </div>
              <div class="col-sm-6">
                <span>{{report.ActivityCount}}</span>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col d-flex gap-2">
                <button style="width: 200px;" class="btn btn-primary btn-configure" (click)="onClickConfigureProject()">
                  <span class="pi pi-cog"></span>
                  <span>{{'SYNCHRONIZATION.ConfigureProject' | translate}}</span>
                </button>
                <button style="width: 200px;" class="btn btn-primary btn-configure" (click)="onClickActivityReport()">
                  <span class="pi pi-chart-bar"></span>
                  <span>{{'SYNCHRONIZATION.ActivityReport' | translate}}</span>
                </button>
                <button style="width: 200px;" class="btn btn-primary btn-configure" (click)="onClickActivityHistory()">
                  <span class="pi pi-calendar-plus"></span>
                  <span>{{'SYNCHRONIZATION.ActivityHistory' | translate}}</span>
                </button>
                <button style="width: 200px;" class="btn btn-primary btn-configure"
                  (click)="onClickUserReportLast30Days()">
                  <span class="pi pi-user"></span>
                  <span>User Report</span>
                </button>
                  <button style="width: 200px;" class="btn btn-primary btn-configure" (click)="onClickComplianceReport()">
                  <span class="pi pi-chart-line"></span>
                  <span>{{'SYNCHRONIZATION.ComplianceReport' | translate}}</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <a class="refresh-link" (click)="getReport()">
                  <span class="pi pi-refresh"></span>
                  <span>{{'SYNCHRONIZATION.Refresh' | translate}}</span>
                </a>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <p-chart type="pie" responsive="false" [data]="pieData" [height]="150"></p-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="panel">
      <div class="row search-container">
        <h4 style="text-align:left">{{'SYNCHRONIZATION.SearchActivity' | translate}}</h4>
        <div class="col-sm-5" *ngIf="!WBSGrouping">
          <input type="search" pInputText placeholder="{{'SHARED.StartTyping' | translate}}"
            (keyup)="term$.next($event.target.value)" class="form-control">
        </div>
        <div class="col-sm-5" *ngIf="WBSGrouping">
          <input type="text" pInputText [(ngModel)]="WbsSearch" (keyup)="wbsTerm$.next($event.target.value)"
            placeholder="{{'SHARED.StartTyping' | translate}}" class="form-control">
        </div>
      </div>

      <div class="row mb-3 align-items-center justify-content-between">
        <div class="col-auto">
          <button id="expandButton" *ngIf="WBSGrouping" class="btn btn-primary" type="button"
            (click)="toggleAccordionTab()">
            {{ (!expandTab ? 'SYNCHRONIZATION.ExpandAll' : 'SYNCHRONIZATION.CollapseAll' ) | translate }}
          </button>
        </div>
        <div class="col-auto d-flex align-items-center">
          <label class="me-2" style="font-weight: bold; font-size: initial;">
            {{'SYNCHRONIZATION.WBSGrouping' | translate}}:
          </label>
          <input id="WBSGroupCheck" type="checkbox" [(ngModel)]="WBSGrouping" data-toggle="toggle"
            (change)="toggleWBSGrouping()" />
        </div>
      </div>
    </div>


    <div class="panel">
      <p-accordion [multiple]="true" *ngIf="!WBSGrouping" [(value)]="openNonGroupedPanels">

    <!-- Approved -->
    <p-accordion-panel
        class="blueTab mt-2"
        value="approved">

        <p-accordion-header>
            Approved: {{ report.ApprovedActivities.length }}/{{ report.ActivityCount }}
            ({{ report.ApprovedPercent | number:'1.2-2' }}%)
        </p-accordion-header>

        <p-accordion-content>
            <app-activity-grid
                [activities]="report.ApprovedActivities"
                [showrejectpanel]="true"
                [searchText]="searchText"
                (reject)="rejectActivity($event)"
                (loadComments)="getActivityComment($event)"
                [projectId]="currentProject?.Id">
            </app-activity-grid>
        </p-accordion-content>

    </p-accordion-panel>

    <!-- Rejected -->
    <p-accordion-panel
        class="blueTab mt-2"
        value="rejected">

        <p-accordion-header>
            Rejected: {{ report.RejectedActivities.length }}/{{ report.ActivityCount }}
            ({{ report.RejectedPercent | number:'1.2-2' }}%)
        </p-accordion-header>

        <p-accordion-content>
            <app-activity-grid
                [activities]="report.RejectedActivities"
                (loadComments)="getActivityComment($event)"
                [searchText]="searchText"
                [projectId]="currentProject?.Id">
            </app-activity-grid>
        </p-accordion-content>

    </p-accordion-panel>

    <!-- Can't Work -->
    <p-accordion-panel
        class="blueTab mt-2"
        value="cantwork">

        <p-accordion-header>
            Can't work: {{ report.CantWorkActivities.length }}/{{ report.ActivityCount }}
            ({{ report.CantWorkPercent | number:'1.2-2' }}%)
        </p-accordion-header>

        <p-accordion-content>
            <app-activity-grid
                [activities]="report.CantWorkActivities"
                (loadComments)="getActivityComment($event)"
                [searchText]="searchText"
                [projectId]="currentProject?.Id">
            </app-activity-grid>
        </p-accordion-content>

    </p-accordion-panel>

    <!-- No Verification -->
    <p-accordion-panel value="noverification" class="blueTab mt-2">

        <p-accordion-header>
            No Verification:
            {{ report.NoVerificationActivities.length }}/{{ report.ActivityCount }}
            ({{ report.NoVerificationPercent | number:'1.2-2' }}%)
        </p-accordion-header>

        <p-accordion-content>

            <div *ngIf="!filterReport.NoVerificationGroupedActivities?.length">
                <h5>{{'SYNCHRONIZATION.NoData' | translate}}</h5>
            </div>

            <div
                class="WbsAccordion"
                *ngFor="let WBS of filterReport.NoVerificationGroupedActivities">

                <p-accordion
                    [multiple]="true"
                    [value]="expandTab ? [WBS.EquipmentClassName] : []">

                    <p-accordion-panel
                        *ngIf="WBS.Jobs?.length"
                        class="whiteTab mt-2"
                        [value]="WBS.EquipmentClassName">

                        <p-accordion-header>
                            {{ WBS.EquipmentClassName }}
                        </p-accordion-header>

                        <p-accordion-content>

                            <div
                                class="JobAccordion"
                                *ngFor="let Job of WBS.Jobs">

                                <p-accordion
                                    [multiple]="true"
                                    [value]="expandTab ? [Job.Name] : []">

                                    <p-accordion-panel
                                        *ngIf="Job.Activities?.length"
                                        class="greyTab mt-2"
                                        [value]="Job.Name">

                                        <p-accordion-header>
                                            {{ Job.Name }}
                                        </p-accordion-header>

                                        <p-accordion-content>

                                            <app-activity-grid
                                                [activities]="Job.Activities"
                                                (loadComments)="getActivityComment($event)"
                                                [searchText]="searchText"
                                                [projectId]="currentProject?.Id">
                                            </app-activity-grid>

                                        </p-accordion-content>

                                    </p-accordion-panel>

                                </p-accordion>

                            </div>

                        </p-accordion-content>

                    </p-accordion-panel>

                </p-accordion>

            </div>

        </p-accordion-content>

    </p-accordion-panel>

    <!-- No Action -->
    <p-accordion-panel
        class="blueTab mt-2"
        value="noaction">

        <p-accordion-header>
            No Action: {{ report.NotTouchedActivities.length }}/{{ report.ActivityCount }}
            ({{ report.NotTouchedPercent | number:'1.2-2' }}%)
        </p-accordion-header>

        <p-accordion-content>
            <app-activity-grid
                [activities]="report.NotTouchedActivities"
                (loadComments)="getActivityComment($event)"
                [searchText]="searchText"
                [projectId]="currentProject?.Id">
            </app-activity-grid>
        </p-accordion-content>

    </p-accordion-panel>

</p-accordion>

     <p-accordion [multiple]="true" *ngIf="WBSGrouping"
                  [value]="expandTab ? ['approved','rejected','cantwork','noverification','noaction'] : []">

    <!-- Approved -->
    <p-accordion-panel class="blueTab mt-2" value="approved">
        <p-accordion-header>
            Approved: {{approvedCount}}/{{report.ActivityCount}}
            ({{report.ApprovedPercent | number:'1.2-2'}}%)
        </p-accordion-header>

        <p-accordion-content>

            <div *ngIf="!filterReport.ApprovedGroupedActivities?.length">
                <h5>{{'SYNCHRONIZATION.NoData' | translate}}</h5>
            </div>

            <div class="WbsAccordion"
                 *ngFor="let WBS of filterReport.ApprovedGroupedActivities">

                <p-accordion [multiple]="true" [value]="expandTab ? [WBS.EquipmentClassName] : []">

                    <p-accordion-panel *ngIf="WBS.Jobs.length"
                                       class="whiteTab mt-2"
                                       [value]="WBS.EquipmentClassName">

                        <p-accordion-header>
                            {{WBS.EquipmentClassName}}
                        </p-accordion-header>

                        <p-accordion-content>

                            <div class="JobAccordion"
                                 *ngFor="let Job of WBS.Jobs">

                                <p-accordion [multiple]="true" [value]="expandTab ? [Job.Name] : []">

                                    <p-accordion-panel *ngIf="Job.Activities.length"
                                                       class="greyTab mt-2"
                                                       [value]="Job.Name">

                                        <p-accordion-header>
                                            {{Job.Name}}
                                        </p-accordion-header>

                                        <p-accordion-content>
                                            <app-activity-grid
                                                [activities]="Job.Activities"
                                                (loadComments)="getActivityComment($event)"
                                                (reject)="rejectActivity($event)"
                                                [showrejectpanel]="true"
                                                [projectId]="currentProject?.Id">
                                            </app-activity-grid>
                                        </p-accordion-content>

                                    </p-accordion-panel>

                                </p-accordion>

                            </div>

                        </p-accordion-content>

                    </p-accordion-panel>

                </p-accordion>

            </div>

        </p-accordion-content>
    </p-accordion-panel>

    <!-- Rejected -->
    <p-accordion-panel class="blueTab mt-2" value="rejected">

        <p-accordion-header>
            Rejected: {{rejectedCount}}/{{report.ActivityCount}}
            ({{report.RejectedPercent | number:'1.2-2'}}%)
        </p-accordion-header>

        <p-accordion-content>

            <div *ngIf="!filterReport.RejectedGroupedActivities?.length">
                <h5>{{'SYNCHRONIZATION.NoData' | translate}}</h5>
            </div>

            <div class="WbsAccordion"
                 *ngFor="let WBS of filterReport.RejectedGroupedActivities">

                <p-accordion [multiple]="true" [value]="expandTab ? [WBS.EquipmentClassName] : []">
                    <p-accordion-panel *ngIf="WBS.Jobs.length"
                                       class="whiteTab mt-2"
                                       [value]="WBS.EquipmentClassName">

                        <p-accordion-header>
                            {{WBS.EquipmentClassName}}
                        </p-accordion-header>

                        <p-accordion-content>

                            <div class="JobAccordion"
                                 *ngFor="let Job of WBS.Jobs">

                                <p-accordion [multiple]="true" [value]="expandTab ? [Job.Name] : []">
                                    <p-accordion-panel *ngIf="Job.Activities.length"
                                                       class="greyTab mt-2"
                                                       [value]="Job.Name">

                                        <p-accordion-header>
                                            {{Job.Name}}
                                        </p-accordion-header>

                                        <p-accordion-content>
                                            <app-activity-grid
                                                [activities]="Job.Activities"
                                                (loadComments)="getActivityComment($event)"
                                                [projectId]="currentProject?.Id">
                                            </app-activity-grid>
                                        </p-accordion-content>

                                    </p-accordion-panel>
                                </p-accordion>

                            </div>

                        </p-accordion-content>

                    </p-accordion-panel>
                </p-accordion>

            </div>

        </p-accordion-content>

    </p-accordion-panel>

    <!-- Can't Work -->
    <p-accordion-panel class="blueTab mt-2" value="cantwork">

        <p-accordion-header>
            Can't Work: {{cantworkCount}}/{{report.ActivityCount}}
            ({{report.CantWorkPercent | number:'1.2-2'}}%)
        </p-accordion-header>

        <p-accordion-content>

            <div *ngIf="!filterReport.CantWorkGroupedActivities?.length">
                <h5>{{'SYNCHRONIZATION.NoData' | translate}}</h5>
            </div>

            <div class="WbsAccordion"
                 *ngFor="let WBS of filterReport.CantWorkGroupedActivities">

                <p-accordion [multiple]="true" [value]="expandTab ? [WBS.EquipmentClassName] : []">
                    <p-accordion-panel *ngIf="WBS.Jobs.length"
                                       class="whiteTab mt-2"
                                       [value]="WBS.EquipmentClassName">

                        <p-accordion-header>
                            {{WBS.EquipmentClassName}}
                        </p-accordion-header>

                        <p-accordion-content>

                            <div class="JobAccordion"
                                 *ngFor="let Job of WBS.Jobs">

                                <p-accordion [multiple]="true" [value]="expandTab ? [Job.Name] : []">
                                    <p-accordion-panel *ngIf="Job.Activities.length"
                                                       class="greyTab mt-2"
                                                       [value]="Job.Name">

                                        <p-accordion-header>
                                            {{Job.Name}}
                                        </p-accordion-header>

                                        <p-accordion-content>
                                            <app-activity-grid
                                                [activities]="Job.Activities"
                                                (loadComments)="getActivityComment($event)"
                                                [projectId]="currentProject?.Id">
                                            </app-activity-grid>
                                        </p-accordion-content>

                                    </p-accordion-panel>
                                </p-accordion>

                            </div>

                        </p-accordion-content>

                    </p-accordion-panel>
                </p-accordion>

            </div>

        </p-accordion-content>

    </p-accordion-panel>

    <!-- No Verification -->
    <p-accordion-panel class="blueTab mt-2" value="noverification">

    <p-accordion-header>
        No Verification: {{noverificationCount}}/{{report.ActivityCount}}
        ({{report.NoVerificationPercent | number:'1.2-2'}}%)
    </p-accordion-header>

    <p-accordion-content>

        <div *ngIf="!filterReport.NoVerificationGroupedActivities?.length">
            <h5>{{'SYNCHRONIZATION.NoData' | translate}}</h5>
        </div>

        <div class="WbsAccordion"
             *ngFor="let WBS of filterReport.NoVerificationGroupedActivities">

            <p-accordion [multiple]="true" [value]="expandTab ? [WBS.EquipmentClassName] : []">

                <p-accordion-panel
                    *ngIf="WBS.Jobs?.length"
                    class="whiteTab mt-2"
                    [value]="WBS.EquipmentClassName">

                    <p-accordion-header>
                        {{WBS.EquipmentClassName}}
                    </p-accordion-header>

                    <p-accordion-content>

                        <div class="JobAccordion"
                             *ngFor="let Job of WBS.Jobs">

                            <p-accordion [multiple]="true" [value]="expandTab ? [Job.Name] : []">

                                <p-accordion-panel
                                    *ngIf="Job.Activities?.length"
                                    class="greyTab mt-2"
                                    [value]="Job.Name">

                                    <p-accordion-header>
                                        {{Job.Name}}
                                    </p-accordion-header>

                                    <p-accordion-content>

                                        <app-activity-grid
                                            [activities]="Job.Activities"
                                            (loadComments)="getActivityComment($event)"
                                            [projectId]="currentProject?.Id">
                                        </app-activity-grid>

                                    </p-accordion-content>

                                </p-accordion-panel>

                            </p-accordion>

                        </div>

                    </p-accordion-content>

                </p-accordion-panel>

            </p-accordion>

        </div>

    </p-accordion-content>

</p-accordion-panel>

    <!-- No Action -->
    <p-accordion-panel class="blueTab mt-2" value="noaction">

    <p-accordion-header>
        No Action: {{notTouchedCount}}/{{report.ActivityCount}}
        ({{report.NotTouchedPercent | number:'1.2-2'}}%)
    </p-accordion-header>

    <p-accordion-content>

        <div *ngIf="!filterReport.NotTouchedGroupedActivities?.length">
            <h5>{{'SYNCHRONIZATION.NoData' | translate}}</h5>
        </div>

        <div class="WbsAccordion"
             *ngFor="let WBS of filterReport.NotTouchedGroupedActivities">

            <p-accordion [multiple]="true" [value]="expandTab ? [WBS.EquipmentClassName] : []">

                <p-accordion-panel
                    *ngIf="WBS.Jobs?.length"
                    class="whiteTab mt-2"
                    [value]="WBS.EquipmentClassName">

                    <p-accordion-header>
                        {{WBS.EquipmentClassName}}
                    </p-accordion-header>

                    <p-accordion-content>

                        <div class="JobAccordion"
                             *ngFor="let Job of WBS.Jobs">

                            <p-accordion [multiple]="true" [value]="expandTab ? [Job.Name] : []">

                                <p-accordion-panel
                                    *ngIf="Job.Activities?.length"
                                    class="greyTab mt-2"
                                    [value]="Job.Name">

                                    <p-accordion-header>
                                        {{Job.Name}}
                                    </p-accordion-header>

                                    <p-accordion-content>

                                        <app-activity-grid
                                            [activities]="Job.Activities"
                                            (loadComments)="getActivityComment($event)"
                                            [projectId]="currentProject?.Id">
                                        </app-activity-grid>

                                    </p-accordion-content>

                                </p-accordion-panel>

                            </p-accordion>

                        </div>

                    </p-accordion-content>

                </p-accordion-panel>

            </p-accordion>

        </div>

    </p-accordion-content>

</p-accordion-panel>

</p-accordion>

    </div>
  </div>
</div>

<!-- <p-dialog header="⚠️ Connection Issues" [(visible)]="showPrimaveraErrorModal" [modal]="true" [closable]="false" [contentStyle]="{'text-align': 'center'}" styleClass="custom-dialog">
  <p [innerHTML]="'SYNCHRONIZATION.ConnectionIssued' | translate" class="dialog-message"></p>
  <ng-template #footer>
    <p-button  icon="pi pi-wifi-off" severity="warn" class="custom-button" (click)="this.LoadOfflineProject()" label="{{'SYNCHRONIZATION.GoOffline' | translate}}" />
    <p-button  icon="pi pi-refresh" severity="success" class="p-button-primary custom-button" (click)="showPrimaveraErrorModal = false;" label="{{'SYNCHRONIZATION.TryAgain' | translate}}" />
  </ng-template>
</p-dialog> -->

<app-activity-upload [projectId]="this.currentProject?.Id" [(display)]="this.showUploadPreview"
  (uploadCompleted)="onUploadCompleted()">
</app-activity-upload>

<!-- Modal Popup for Missing Projects -->
<div>
  <!-- Dialog for missing projects -->
  <p-dialog header="{{ 'SYNCHRONIZATION.MissingProject' | translate }}" [(visible)]="displayMissingProjects"
    [modal]="true" [closable]="true" [style]="{overflowY: 'auto', overflowX: 'auto'}">

    <ng-container *ngIf="missingProjects?.length > 0; else noMissingProjects">
      <div class="text-danger font-weight-bold" *ngIf="lastUpdatedTime">
        {{ 'SYNCHRONIZATION.LastSyncDateandTime' | translate }}: {{ lastUpdatedTime }}
      </div>
      <div *ngFor="let project of missingProjects" class="text-danger font-weight-bold">
        <span>{{ project.ProjectId }} - {{ project.ProjectName }}</span>
      </div>
      <div class="mt-2">
        <button type="button" class="btn btn-warning" (click)="downloadMissedProjects()">
          <span>{{ 'SYNCHRONIZATION.DownloadMissingProject' | translate }}</span>
        </button>
      </div>
    </ng-container>

    <!-- Template shown when no missing projects -->
    <ng-template #noMissingProjects>
      <div class="text-danger font-weight-bold" *ngIf="lastUpdatedTime">
        {{ 'SYNCHRONIZATION.LastSyncDateandTime' | translate }}: {{ lastUpdatedTime }}
      </div>
      <div class="text-success font-weight-bold">
        {{ 'SYNCHRONIZATION.AllProjectsUpToDate' | translate }}
      </div>
    </ng-template>
  </p-dialog>
</div>